import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {useCallback} from "react";

/**
 * Returns a callback which clears all search params from the current url
 *
 * ex: /courses/course/la-level-2?class=123 -> /courses/course/la-level-2
 * @returns a function which clears all search params from the current page's url when called
 */
export const useClearSearchParams = ({
	clearParams = [],
}: {
	clearParams?: string[];
} = {}) => {
	const router = useRouter();
	const pathname = usePathname();

	const searchParams = useSearchParams();
	const newParamString = Array.from(searchParams.entries())
		.filter(([key]) => !clearParams.includes(key))
		.map(([key, value]) => `${key}=${value}`)
		.join("&");

	const clearSearchParams = useCallback(() => {
		router.replace(
			`${pathname}${clearParams.length > 0 ? `?${newParamString}` : ""}`,
			{scroll: false}
		);
	}, [router, pathname, newParamString, clearParams]);
	return clearSearchParams;
};
